import React, { useRef } from 'react';
import google from '@ui/assets/images/google.png';
import { Button, IButtonSize } from '../atoms/button';
import { sendGAEvent } from '@next/third-parties/google';
import { useAnalytics } from '@ui/analytics';

interface IOauthButton {
  type: string;
  url: string;
  size?: IButtonSize;
  claim?: string;
  badgeId?: string | null;
  claimCode?: string | null;
}

export const OauthButton: React.FC<IOauthButton> = ({
  type,
  url,
  size,
  claim,
  badgeId,
  claimCode,
}) => {
  const image = {
    google: google,
  }[type];

  const oauthEventSentRef = useRef(false);
  const { track } = useAnalytics();

  const handleOAuthClick = () => {
    if (!oauthEventSentRef.current) {
      sendGAEvent('event', 'SignInWithGoogleClicked', {
        signin_time: new Date().toISOString(),
      });

      // Analytics tracking
      track({
        eventName: 'oauth_button_clicked',
        properties: {
          oauth_provider: type,
          oauth_url: url,
          has_claim: !!claim,
          has_badge_id: !!badgeId,
          has_claim_code: !!claimCode,
          badge_id: badgeId,
          claim_code: claimCode,
          auth_method: 'oauth',
          timestamp: new Date().toISOString(),
        },
      });

      oauthEventSentRef.current = true;
    }

    const queryParams = new URLSearchParams();
    if (claim) {
      queryParams.append('claim', encodeURIComponent(claim));
    }

    if (badgeId) {
      queryParams.append('badgeId', encodeURIComponent(badgeId));
    }

    if (claimCode) {
      queryParams.append('claimCode', encodeURIComponent(claimCode));
    }

    const finalURL = `${process.env['NEXT_PUBLIC_API_URL']}${url}?${queryParams.toString()}`;
    window.open(finalURL, '_self');
  };

  return (
    <Button onClick={handleOAuthClick} type="secondary" className="mt-4 w-full" size={size}>
      <img src={image?.src} alt="icon" className="mr-[10px] h-[24px] w-[24px]" />
      <span>{claim ? 'Login' : 'Continue'} With Google</span>
    </Button>
  );
};
